import { ApiItemType } from "../model";

/** Helpers for working with the API */
export class ApiLogic {

  /** Gets the type string for an API item type enumeration. */
  public static getType(apiListItem: ApiItemType): string | null {
    if (!apiListItem || apiListItem.trim().length < 2) {
      return null;
    }
    switch (apiListItem) {
      case ApiItemType.Calculation:
      case ApiItemType.CalculationPaid:
        return "Calculation";
      case ApiItemType.EarningsPaymentReport:
        return "EarningsPayment";
      case ApiItemType.PayerSummaryReport:
        return "PayerSummary";
      case ApiItemType.ListItems:
        return "ApiListItem[]";
      case ApiItemType.Undefined:
        return null;
      default:
        return apiListItem.substring(0, 1).toUpperCase() + apiListItem.substring(1);
    }
  }

}